export const WEBCHAT_SOURCE = 'chatbot_site';

export const WEBCHAT_CUSTOMER_IDENTIFIER_PREFIX = 'cliente-';

export const WEBCHAT_VISITOR_IDENTIFIER_PREFIX = 'visitante-';

/**
 * Campo personalizado da Callbell para cada dado de origem do visitante. O bot
 * lê esses campos ao criar o lead no Vectis (ED-7201).
 */
export const WEBCHAT_TRACKING_FIELDS = {
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  term: 'utm_term',
  content: 'utm_content',
  facebookId: 'facebook_id',
  googleId: 'google_id',
  googleIdType: 'google_id_type',
  referrer: 'referrer',
  ip: 'ip',
  page: 'pagina',
} as const;
